<div class="audit-toolbar">
  <label class="audit-filter">
    <input type="checkbox" [(ngModel)]="auditUserOnly" />
    Nur Benutzer-Änderungen
  </label>
  <button type="button" class="audit-reload" (click)="reloadAudit()" [disabled]="auditLoading" title="Neu laden">
    <cds-icon shape="refresh" size="12"></cds-icon>
  </button>
</div>
<div class="audit-list" *ngIf="visibleAuditEntries.length > 0; else auditEmpty">
  <div class="audit-entry" *ngFor="let e of visibleAuditEntries">
    <div class="audit-entry-head">
      <span class="audit-time">{{ auditTime(e.occurredAt) | date: 'dd.MM.yyyy HH:mm:ss' }}</span>
      <span class="audit-actor" [class.audit-actor-system]="e.actor === 'System' || e.actor === 'External'">{{ e.actor }}</span>
      <span class="audit-action" *ngIf="e.action && e.action !== 'Updated'">{{ e.action === 'Created' ? 'Angelegt' : 'Gelöscht' }}</span>
      <span class="audit-source" [title]="e.source">{{ e.source }}</span>
    </div>
    <div class="audit-change" *ngFor="let c of e.changes">
      <span class="audit-prop">{{ c.prop }}:</span>
      <span class="audit-old" [title]="c.old">{{ c.old ?? '∅' }}</span>
      <span class="audit-arrow">→</span>
      <span class="audit-new" [title]="c.new">{{ c.new ?? '∅' }}</span>
    </div>
  </div>
</div>
<ng-template #auditEmpty>
  <div class="audit-empty" *ngIf="!auditLoading">Keine Einträge.</div>
</ng-template>
<div class="audit-footer">
  <clr-spinner *ngIf="auditLoading" clrSmall clrInline>Laden…</clr-spinner>
  <button type="button" class="btn btn-sm btn-link" *ngIf="auditNextToken && !auditLoading" (click)="loadMoreAudit()">
    Mehr laden
  </button>
</div>
